const Results = () => {
    return (
        <>
            <p className='Help__Subtitle'>Exportar reporte completo</p>
            <img src='/img/support/help/instructor/results/2.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Exportar reporte completo</span>?</p>
            <p>Permite generar un archivo en formato Excel con todos los resultados de las evaluaciones aplicadas por los Ztudiantes. Este archivo puede utilizarse para aplicar filtros y organizar la información según las necesidades del análisis académico.</p>
            <p>La exportación incluye datos detallados que facilitan el seguimiento del desempeño y la elaboración de reportes externos.</p>

            <p className='Help__Subtitle'>Filtros</p>
            <img src='/img/support/help/instructor/results/3.png' className='Help__Image' />
            <p>¿Cómo funcionan los filtros?</p>
            <p>Permite aplicar criterios para visualizar el avance de los Ztudiantes según curso y grupo, Aplicar filtro muestra únicamente la información relacionada con esas condiciones.</p>
            <p>Estos filtros facilitan la consulta del progreso académico y permiten organizar los datos de manera precisa, pudiendo exportarlos a Excel.</p>

            <p className='Help__Subtitle'>Exportar</p>
            <img src='/img/support/help/instructor/results/4.png' className='Help__Image' />
            <p>¿Cómo funciona el botón <span className='Help__Text--Highlight'>Exportar</span>?</p>
            <p>Permite generar un archivo en formato Excel con la información mostrada en pantalla. Puede exportar los datos de un registro específico o de todos los registros filtrados previamente, según las necesidades del análisis.</p>
            <p>Esta opción facilita la organización externa y el uso de herramientas adicionales para aplicar filtros o realizar cálculos.</p>

            <p className='Help__Subtitle'>Buscar</p>
            <img src='/img/support/help/instructor/results/5.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Buscar</span>?</p>
            <p>Permite localizar rápidamente un ztudiante, ya sea por nombre o usuario. Escribe el dato en el campo de búsqueda y Ztudia mostrará solo los resultados relacionados, ocultando los demás para facilitar la gestión y visualización de los resultados obtenidos.</p>
        </>
    )
}

export { Results };